import { Row, Col, Layout } from 'antd'
import WeaverLoading from './WeaverLoading'

Loading = (props) ->
  <Layout style={{ height: '100vh', marginTop: props.marginTop, props.style... }}>
    <Row style={{ flex: 'auto' }} justify="center" type="flex" align="middle">
      <Col style={{ textAlign: "center" }}>
        <WeaverLoading { props... } />
      </Col>
    </Row>
  </Layout>

export default Loading
